const alertIconGrey = `
<svg width='18px' height='18px' viewBox='0 0 18 18' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'>
    <!-- Generator: Sketch 53.2 (72643) - https://sketchapp.com -->
    <title>Shape</title>
    <desc>Created with Sketch.</desc>
    <g id='Settings-' stroke='none' fill='none'>
        <g id='DB-Settings---General-Copy' transform='translate(-815.000000, -342.000000)' fill-rule='nonzero'>
            <g id='Group-2' transform='translate(470.000000, 235.000000)'>
                <g id='ic-error-outline-24px-copy-3' transform='translate(344.000000, 106.000000)'>
                    <path fill='#e0e0e0' d='M9.16666667,12.5 L10.8333333,12.5 L10.8333333,14.1666667 L9.16666667,14.1666667 L9.16666667,12.5 Z M9.16666667,5.83333333 L10.8333333,5.83333333 L10.8333333,10.8333333 L9.16666667,10.8333333 L9.16666667,5.83333333 Z M9.99166667,1.66666667 C5.39166667,1.66666667 1.66666667,5.4 1.66666667,10 C1.66666667,14.6 5.39166667,18.3333333 9.99166667,18.3333333 C14.6,18.3333333 18.3333333,14.6 18.3333333,10 C18.3333333,5.4 14.6,1.66666667 9.99166667,1.66666667 Z M10,16.6666667 C6.31666667,16.6666667 3.33333333,13.6833333 3.33333333,10 C3.33333333,6.31666667 6.31666667,3.33333333 10,3.33333333 C13.6833333,3.33333333 16.6666667,6.31666667 16.6666667,10 C16.6666667,13.6833333 13.6833333,16.6666667 10,16.6666667 Z' id='Shape'></path>
                </g>
            </g>
        </g>
    </g>
</svg>`;

export default alertIconGrey;
